module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Introduction#ch"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Part1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART I: THE ITALIAN CAMPAIGN")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter1#ch"
    }
  }, [_vm._v("The Allied Advance to the Gustav Line")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter2#ch"
    }
  }, [_vm._v("Cassino")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter3#ch"
    }
  }, [_vm._v("The Rescue of the Monastery Treasures")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Part2"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART II: OPENING MOVES ON THE GUSTAV LINE")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/14_Chapter4#ch"
    }
  }, [_vm._v("US II Corps moves up to the Rapido River Line (January 3-16)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15_Chapter5#ch"
    }
  }, [_vm._v("The Attack of the Corps Expéditionnaire Français (January 12-16)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter6#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The X Corps Attack across the Garigliano (January 17-28)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter7#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The US 36th Division’s Attack over the Lower Gari (January 20-22)")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Part3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART III: THE FIRST BATTLE")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter8#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Attack of the CEF (January 21-February 4)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter9#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The US 34th Division’s Attack on Monte Cassino (January 24-February 12)")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Part4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART IV: THE SECOND BATTLE")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter10#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Formation of the New Zealand Corps")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter11#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Decision to Bomb the Monastery")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bombing of the Abbey (February 15)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter13#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Preliminary Attacks on Point 593 (February 15-17)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter14#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The 4th Indian Division’s Monastery Attack (February 17-18)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter15#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Zealanders’ Attack on Cassino (February 17-18)")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Part5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART V: THE THIRD BATTLE")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter16#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operation ‘Dickens’")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter17#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bombing of the Town (March 15)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter18#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Zealanders’ Attack into the Town (March 15-16)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter19#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The 4th Indian Division reaches Hangman’s Hill (March 15-17)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter20#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Attack on the Railway Station (March 17)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter21#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reducing the South-West Quadrant (March 18)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter22#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operation ‘Hector’ — The Attack on the Monastery (March 19)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter23#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operation ‘Revenge’ — Attack up Cavendish Road (March 19)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter24#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The End of the Offensive (March 20-22)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Chapter25#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deadlock (March 23-May 10)")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Part6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART VI: THE FOURTH BATTLE")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter26#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operation ‘Diadem’")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Chapter27#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("US II Corps along the Coast (May 11-17)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Chapter28#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The CEF in the Aurunci Mountains (May 11-17)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter29#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("British XIII Corps in the Liri Valley (May 11-17)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Chapter30#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Polish II Corps on Monte Cassino (May 11-12)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Chapter31#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fall of Cassino (May 17-18)")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46_Part7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART VII: THE END OF THE BATTLE")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47_Chapter32#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breaking the Hitler Line (May 18-25)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/48_Chapter33#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Junction of the Cassino and Anzio Fronts (May 25)")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/49_Part8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART VIII: EPILOGUE")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50_Chapter34#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Casualties")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/51_Chapter35#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cassino Today")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/52_Chapter36#ch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Allied Strategy and Tactics and the Role of Ultra")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/53_Archive_Sources",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Archive Sources")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/54_Photograph_Credits",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photograph Credits")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1318eeb7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 75
// module chunks = 0